module.exports = __webpack_public_path__ + "static/media/hakaba.7a1dc387.png";